import React from 'react';

import { useGetSpeiBanksByNameQuery } from '@/api/v1';
import { SpeiBank } from '@/types/speiBank';

export const useSpeiBankSearch = (keyword: string): readonly SpeiBank[] => {
  const [debouncedKeyword, setDebouncedKeyword] = React.useState<string>(keyword);
  const { data: banks = [] } = useGetSpeiBanksByNameQuery(debouncedKeyword);

  React.useEffect((): VoidFunction => {
    const timeout = setTimeout((): void => {
      setDebouncedKeyword(keyword);
    }, 500);

    return (): void => {
      clearTimeout(timeout);
    };
  }, [keyword]);

  return banks;
};
